import styled from 'styled-components';
import { Typography } from '@mesa-labs/mesa-ui';

export const Header = styled(Typography.H2)`
  color: #0E121B;
  font-family: ${(props) => props.theme.fonts.grotesk};
  font-size: 32px;
  font-weight: 500;
  line-height: 40px;
  letter-spacing: -0.5px;
  padding: 0px 0px 24px 0px;
`;
